import { render, staticRenderFns } from "./ImageViewer.vue?vue&type=template&id=5ddd5ba4&scoped=true"
import script from "./ImageViewer.vue?vue&type=script&lang=ts"
export * from "./ImageViewer.vue?vue&type=script&lang=ts"
import style0 from "./ImageViewer.vue?vue&type=style&index=0&id=5ddd5ba4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddd5ba4",
  null
  
)

export default component.exports